export enum MentorScriptElementType {
    Text = 'Text',
    Say = 'Say',
    Do = 'Do',
    Tip = 'Tip',
    Warning = 'Warning',
}
